// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingNavbar-cls1_4my","cls2":"CoScientistLandingNavbar-cls2_Zd_ CoScientistLandingNavbar-cls1_4my"};